import { SignalingClient } from 'amazon-kinesis-video-streams-webrtc';
import { webRTC_info } from '../api/WebRTC';
import { getEncounterRecord } from '../apps/api/AppointmentRequests';
import { jwtDecode } from 'jwt-decode';

class ChannelHelper {
  static IngestionMode = {
    OFF: 0,
    ON: 1,
    DETERMINE_THROUGH_DESCRIBE: 2,
  };

  constructor(encounterId, clientArgs, endpoint, role, ingestionMode, loggingPrefix, clientId) {
    this.encounterId = encounterId;
    this.clientArgs = clientArgs;
    this.endpoint = endpoint;
    this.role = role;
    this.ingestionMode = ingestionMode;
    this.loggingPrefix = loggingPrefix;
    this.clientId = clientId;
  }

  async init() {
    try {
      const token = localStorage.getItem('authentication');
      let orgId = null;

      if (token) {
        const decoded = jwtDecode(token);
        orgId = decoded?.["custom:orgId"];
      }

      if (!this.encounterId) {
        throw new Error("Encounter ID is required");
      }

      if (!orgId) {
        throw new Error("Organization ID is required from token");
      }

      const encounterRecord = await getEncounterRecord({ encounterId: this.encounterId });
      const data = await webRTC_info({ deviceID: encounterRecord.data.deviceID, userType: "VIEWER" }, orgId);

      if (!data.status) {
        throw new Error("API error: " + data.message);
      }

      const result = data.result;
      this.channelArn = result.channelARN;
      console.log(this.loggingPrefix, 'Channel ARN:', this.channelArn);
      
      const endpointsArray = result.signalEndpoint.ResourceEndpointList;
      const endpoints = endpointsArray.reduce((acc, ep) => {
        acc[ep.Protocol] = ep.ResourceEndpoint;
        return acc;
      }, {});
      console.log(this.loggingPrefix, 'Endpoints:', endpoints);
      
      this.iceServers = result.iceServers.map(server => ({
        urls: server.Uris,            
        username: server.Username,
        credential: server.Password   
      }));
      
      this.region = result.region;
      this.stsCredentials = result.stsCredentials;
      
      this.signalingClient = new SignalingClient({
        channelARN: this.channelArn,
        channelEndpoint: endpoints.WSS,
        role: this.role,
        region: this.region,
        credentials: {
          accessKeyId: this.stsCredentials.AccessKeyId,
          secretAccessKey: this.stsCredentials.SecretAccessKey,
          sessionToken: this.stsCredentials.SessionToken,
        },
        clientId: this.clientId,
      });
    } catch (e) {
      console.error(this.loggingPrefix, 'Error initializing ChannelHelper:', e);
      throw e;
    }
  }

  getSignalingClient() {
    return this.signalingClient;
  }
}

export default ChannelHelper;